import React, { ReactNode } from 'react';
import { Button } from '@/src/shared/components/Button';
import { useIsMobile } from '@/src/shared/hooks/utils/useIsMobile';
import { useLanding } from '@/src/containers/Landings/LandingProvider/LandingProvider';

interface Props {
  className?: string;
  children?: ReactNode;
  fullWidth?: boolean;
}

export function CtaButton({
  className,
  children = 'Get your Video for Free',
  fullWidth,
}: Props) {
  const isMobile = useIsMobile();
  const { openRegistrationPopup } = useLanding();

  const handleClick = () => {
    openRegistrationPopup();
  };

  return (
    <Button
      fullWidth={fullWidth}
      color="primary"
      size={isMobile ? 'xl' : '2xl'}
      className={className}
      onClick={handleClick}
    >
      {children}
    </Button>
  );
}
